import type { TyreFitmentView } from '@chukua/common';
import { useVehicleTyreLayout } from '../hooks/use-vehicle-tyre-layout';
import { VehicleTyreDiagram } from './VehicleTyreDiagram';

/** The vehicle a fitted tyre is on, in 3D, with its position picked out. Quietly absent if the vehicle's layout can't be read: the summary already names the position. */
export function TyreLocationDiagram({ fitment }: { fitment: TyreFitmentView }) {
  const { state } = useVehicleTyreLayout(fitment.vehicleKind, fitment.vehicleId);
  if (state.status !== 'loaded') return null;
  return (
    <section className="flex flex-col gap-3">
      <h2 className="m-0 text-base font-semibold text-fg">Where it is</h2>
      <VehicleTyreDiagram layout={state.layout} selectedCode={fitment.positionCode} className="lg:static" />
    </section>
  );
}
